"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageFrame = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const PageFrame_module_css_1 = __importDefault(require("./PageFrame.module.css"));
const MobilePageFrame_1 = require("./MobilePageFrame");
const DesktopPageFrame_1 = require("./DesktopPageFrame");
/**
 *
 */
function PageFrame({ locale, messages, appType, pageType, downloadUrl, webClientId, isMobile = false, children, localeChange, showSnapchatAdsUrl, showCreateStoryLink, disableMobileBottomNav, showWhiteBgOnBottomNav, mobilePageContainerRef, hideMobileNavigation, hideDefaultFooter, footerProps, footerExperimentProps, }) {
    const mobileNavigationProps = {
        appType,
        disableMobileBottomNav,
        showWhiteBgOnBottomNav,
        mobilePageContainerRef,
    };
    const desktopNavigationProps = {
        appType,
        showSnapchatAdsUrl,
        showCreateStoryLink,
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("main", { className: PageFrame_module_css_1.default.pageFrame, children: isMobile ? ((0, jsx_runtime_1.jsx)(MobilePageFrame_1.MobilePageFrame, { webClientId: webClientId, locale: locale, messages: messages, localeChange: localeChange, navigationProps: mobileNavigationProps, footerProps: footerProps, footerExperimentProps: footerExperimentProps, hideMobileNavigation: hideMobileNavigation, hideDefaultFooter: hideDefaultFooter, pageType: pageType, downloadUrl: downloadUrl, children: children })) : ((0, jsx_runtime_1.jsx)(DesktopPageFrame_1.DesktopPageFrame, { webClientId: webClientId, locale: locale, messages: messages, localeChange: localeChange, navigationProps: desktopNavigationProps, hideDefaultFooter: hideDefaultFooter, footerProps: footerProps, pageType: pageType, downloadUrl: downloadUrl, children: children })) }) }));
}
exports.PageFrame = PageFrame;
//# sourceMappingURL=PageFrame.js.map